import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {BillingAlertsService} from "../../services/billing-alerts.service";

export class editBillingAccountCtrl implements IController {

  billingAccount: any;

  private loading: any;
  private disabled: any;
  private baTypes: any;
  private billingAccountCopy: any;

  /* @ngInject */
  constructor(private billingAccountConstants, private $billingAccounts, private $mdDialog, private billingAlertsService: BillingAlertsService) {
  }

  $onInit() {
    this.loading = false;
    this.disabled = false;
    this.baTypes = this.billingAccountConstants.types;
    this.billingAccountCopy = angular.copy(this.billingAccount);

    if (!this.billingAccountCopy.billingContacts) {
      this.billingAccountCopy.billingContacts = [];
    }
  };

  $onChanges(changes) {
    if (changes.deliveryId && !changes.deliveryId.isFirstChange()) {
      this.$onInit();
    }
  }


  validate() {
    var res = _.get(this.billingAccount, 'accountingName.length') &&
      _.get(this.billingAccount, 'type.length');
    this.disabled = !res;
  };

  submit() {
    this.loading = true;
    this.$billingAccounts(this.billingAccountCopy.id).$post(this.billingAccountCopy)
      .then((billingAccount) => {
        this.billingAccount = billingAccount;
        this.billingAccountCopy = angular.copy(this.billingAccount);
        this.billingAlertsService.updateBillingAccountSuccess();
        this.$mdDialog.hide();
      })
      .catch(() => {
        this.billingAlertsService.updateBillingAccountError();
      })
      .finally(() => {
        this.loading = false;
      })
  }

}

angular
  .module('bringoz.admin.billing-accounts')
  .component('editBillingAccount', {
    bindings: {
      billingAccount: '<'
    },
    template: require('./edit-billing-account.html').default,
    controller: editBillingAccountCtrl
  });
